<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><a href="#/toc#toc-preface003"></a></h1>
<p class="center2"><span><a id="fig001"><img alt="image" height="248" src="images/Art_P12.jpg" width="371"/></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface003.vue?4ff8ec72